import { Card, Typography } from 'antd';
import { DOMAIN } from 'config/api-variables';
import { AppDefaults } from 'config/global-enums';
import { getHostName } from 'utils/local-storage/user';
import { capitalizeFirst } from 'utils/tools/data-transformers';

const { Title } = Typography;

export default function DomainNotFoundPage() {
  const subDomainName = getHostName.split('.')[0];
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f0f0',
      }}
    >
      <Card
        style={{
          maxWidth: '50%',
          textAlign: 'center',
          borderRadius: 8,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#ffffff',
        }}
      >
        <img
          src="/logo-emoji-black.svg"
          alt="Logo"
          style={{ width: 100, height: 'auto', marginBottom: 20 }}
        />
        <Title level={3}>Oops! We couldn't find you</Title>
        <Typography.Paragraph>
          Your business, <strong>{capitalizeFirst(subDomainName)}</strong> is
          either not registered with us or there seems to be an issue.
        </Typography.Paragraph>
        <Typography.Paragraph>
          You're welcome to register your business by clicking on this link:{' '}
          <a href={DOMAIN + '/signup'}>{AppDefaults.APP_NAME}</a>.
          Alternatively, please verify the spelling of your business name. If
          you are already a registered entity, kindly contact us at
          support@cleandesk.ai.
        </Typography.Paragraph>
      </Card>
    </div>
  );
}
